import { BaseEntity } from "../../core";

export class Image extends BaseEntity {
    public number: number;
    public documentType: string;
    public pathUrl: string;
    public dateAssignedString: string;
    public dateAssigned: Date;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/image.ts